import { createFileRoute } from "@tanstack/react-router";
import { GestaoAtendimentoPage } from "@/components/pages/GestaoAtendimentoPage";

const SITE = "https://kentro.com.br";

const META = {
  en: {
    title: "Digital Support Management with AI | Kentro",
    desc: "The most complete support management platform: AI chatbot, WhatsApp, real-time KPIs and integrations. Serve better and sell more with Kentro.",
    ogTitle: "Digital Support Management with AI | Kentro",
    ogDesc: "AI chatbot, WhatsApp, real-time KPIs and integrations.",
  },
  es: {
    title: "Gestión de Atención Digital con IA | Kentro",
    desc: "La plataforma de gestión de atención más completa: chatbot con IA, WhatsApp, KPIs en tiempo real e integraciones. Atiende mejor y vende más con Kentro.",
    ogTitle: "Gestión de Atención Digital con IA | Kentro",
    ogDesc: "Chatbot con IA, WhatsApp, KPIs en tiempo real e integraciones.",
  },
} as const;

export const Route = createFileRoute("/$locale/gestao-de-atendimento")({
  head: ({ params }) => {
    const loc: "en" | "es" = params.locale === "es" ? "es" : "en";
    const m = META[loc];
    return {
      meta: [
        { title: m.title },
        { name: "description", content: m.desc },
        { property: "og:title", content: m.ogTitle },
        { property: "og:description", content: m.ogDesc },
        { property: "og:url", content: `${SITE}/${loc}/gestao-de-atendimento` },
        { property: "og:locale", content: loc === "es" ? "es_ES" : "en_US" },
      ],
      links: [
        { rel: "canonical", href: `${SITE}/${loc}/gestao-de-atendimento` },
        { rel: "alternate", hrefLang: "pt-BR", href: `${SITE}/gestao-de-atendimento` },
        { rel: "alternate", hrefLang: "en", href: `${SITE}/en/gestao-de-atendimento` },
        { rel: "alternate", hrefLang: "es", href: `${SITE}/es/gestao-de-atendimento` },
        { rel: "alternate", hrefLang: "x-default", href: `${SITE}/gestao-de-atendimento` },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: loc === "es" ? "Inicio" : "Home", item: `${SITE}/${loc}/` },
              { "@type": "ListItem", position: 2, name: 'Gestão de Atendimento', item: `${SITE}/${loc}/gestao-de-atendimento` },
            ],
          }),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": 'WebPage',
            "@id": `${SITE}/${loc}/gestao-de-atendimento`,
            url: `${SITE}/${loc}/gestao-de-atendimento`,
            name: m.title,
            description: m.desc,
            inLanguage: loc === "es" ? "es" : "en",
            isPartOf: { "@type": "WebSite", "@id": `${SITE}/#website` },
          }),
        },
      ],
    };
  },
  component: GestaoAtendimentoPage,
});
